import type { SongWithSinger } from 'shared-types/song';

export interface PartialSong {
  id: string;
  title: string;
  artist: { name: string };
  length: number;
  singerName?: string;
}

export interface LastSong {
  disableFeatures: boolean;
  song: SongWithSinger | null;
}

export interface Volume {
  volumeBarDisplayed: boolean;
  muted: boolean;
}

export type PlayerState = {
  currentSong: PartialSong | null;
  lastSong: LastSong;
  waitingList: SongWithSinger[];
  waitingListPosition: ScrollPosition;
  isWaitlingListSongDragging: boolean;
  volume: Volume;
  currentSongEndTimestampInSecond: number;
  musicPitchValue: number;
};

export enum ScrollPosition {
  TOP = 0,
  BOTTOM = 1,
}
